module.exports = __webpack_public_path__ + "img/album12_01.a1e63195.jpg";